<template>
    <main :class="['pane-preview-container']" v-if="hasPane">
        <pane-order-template :tools="tools" :hideHeader="hideHeader" />
        <pane-package-template :tools="tools" :hideHeader="hideHeader "/>
        <pane-item-template :tools="tools" :hideHeader="hideHeader "/>
        <pane-instance-template :tools="tools" :hideHeader="hideHeader" />
        <pane-user-template :tools="tools" :hideHeader="hideHeader" />
    </main>
</template>

<script>
    import OrderPaneTemplate from '../pane-templates/OrderPaneTemplate';
    import InstancePaneTemplate from '../pane-templates/InstancePaneTemplate';
    import ItemPaneTemplate from '../pane-templates/ItemPaneTemplate';
    import PackagePaneTemplate from '../pane-templates/PackagePaneTemplate';
    import UserPaneTemplate from '../pane-templates/UserPaneTemplate';

    export default {
        name: 'pane-preview-container',
        components: {
            'pane-order-template': OrderPaneTemplate,
            'pane-instance-template': InstancePaneTemplate,
            'pane-item-template': ItemPaneTemplate,
            'pane-package-template': PackagePaneTemplate,
            'pane-user-template': UserPaneTemplate,
        },
        props: ['tools', 'hideHeader'],
        computed: {
            content() {
                return this.tools.currentView.data.pane.data;
            },
            hasPane() {
                return !!(this.tools.currentView.data && this.tools.currentView.data.pane);
            }
        },
    };
</script>

<style>
    .pane-preview-container {
        width: 100%;
        height: 100%;
        /*overflow: hidden;*/
    }

    .pane-template {
        height: 100%;
        overflow: hidden;
        position: relative;
    }

    .pane-preview-container .ps__scrollbar-x-rail {
        display: none !important;
    }
</style>



// WEBPACK FOOTER //
// PanePreviewContainer.vue?7a94ddce